<template>
  <div class="flex justify-end items-center">
    <template v-if="!$auth.check()">
      <a
        @click="show.register = true"
        class="text-sm cursor-pointer text-yellow-8 hover:text-yellow-7"
      >Register</a>
      <nx-button class="ml-2" @click="show.login = true" type="secondary">Login</nx-button>
    </template>
    <template v-else>
      <router-link
        class="text-sm cursor-pointer text-yellow-8 hover:text-yellow-7"
        :to="{name: 'profile'}"
      >{{ $auth.user().username }}</router-link>
      <nx-button class="ml-2" @click="logout" type="secondary">Logout</nx-button>
    </template>

    <portal to="modal-portal">
      <register-form v-if="show.register" @close="show.register = false" @success="registerSuccess"></register-form>
    </portal>

    <portal to="modal-portal">
      <login-form v-if="show.login" @close="show.login = false"></login-form>
    </portal>
  </div>
</template>

<script>
import RegisterForm from "./Forms/RegisterForm"
import LoginForm from "./Forms/LoginForm"
import { EventBus } from "@/events"

export default {
  data() {
    return {
      show: {
        login: false,
        register: false
      }
    }
  },

  components: {
    LoginForm,
    RegisterForm
  },

  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: true,
        redirect: null,
        success() {
          if (
            this.$route.meta.auth &&
            this.$route.meta.auth !== false &&
            this.$route.meta.auth !== undefined
          ) {
            this.$router.push({ name: "channels.index" })
          }

          this.$toasted.show("You have been logged out.")
          EventBus.$emit("auth:logout")
        }
      })
    },
    registerSuccess() {
      this.show.register = false
      this.show.login = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.login !== undefined) {
        this.show.login = true
      }
    })
    EventBus.$on("login:show", () => (this.show.login = true))
  }
}
</script>
